// extracted by mini-css-extract-plugin
export default {"message":"InlineMessage_message__NXdsO","success":"InlineMessage_success__bvMiS","warning":"InlineMessage_warning__l9j0J","error":"InlineMessage_error__xQca0"};